import { TDateISO, TDateISODate } from "api/common/types/datetime.types";
import { standardDateFormat } from "utils/timeUtils";

type PotentialDate = TDateISO | TDateISODate | null | undefined;

export const dataGridDateGetter = (value: PotentialDate) =>
  value ? new Date(value) : null;

export const dataGridDateOnlyGetter = (value: PotentialDate) =>
  value ? new Date(standardDateFormat(value)) : null;
